module.exports = __webpack_public_path__ + "static/img/zhongbiao.5d6c5e13.png";